/* eslint-disable no-console */

const NO_OP = () => {};

export const Logger = {
  log: console.log,
  error: console.error,
  debug: console.debug,
  group: console.group,
  groupCollapsed: console.groupCollapsed,
  groupEnd: console.groupEnd,
};

// Disable logging when not in development
if (LDT_ENV !== 'development') {
  Object.keys(Logger).forEach((key) => {
    if (key !== 'error') {
      Logger[key] = NO_OP;
    }
  });
}
